import { Head, CleanContent } from './ui';
import { growth, excluded } from '../data';

export default function GrowthGuide() {
  return (
    <CleanContent><section className="py-5">
        <div className="container">
          <Head eyebrow="Growth Methodology" title="Build Your Way to the Next Star"
            text="Advancing through the 10 ranks follows systematic operational growth, verified transaction integrity, and prompt relationship handling" />
          <div className="row g-3">
            <div className="col-lg-7">
              {growth.map(([t, d], i) => (
                <div className="border border-line rounded-3 p-3 mb-2 d-flex gap-3" key={t}>
                  <span className="badge badge-star rounded-circle d-flex align-items-center justify-content-center" style={{ width: 28, height: 28 }}>{i + 1}</span>
                  <div><div className="h-md">{t}</div><p className="p-sm mb-0">{d}</p></div>
                </div>
              ))}
            </div>
            <div className="col-lg-5">
              <div className="bg-navy rounded-3 p-4 h-100">
                <h3 className="h-md fs-4 mb-2 text-white">You Can Buy Visibility<br />You Cannot Buy Reputation</h3>
                <p className="p-sm mb-2">SELECTEZI maintains strict neutrality, the following practices are systematically excluded from Star calculations</p>
                {excluded.map((x) => (
                  <div className="p-sm mb-1" key={x}><i className="bi bi-x-circle-fill me-2" style={{ color: "#fca5a5" }} />{x}</div>
                ))}
                <div className="p-sm mt-3 border-top pt-2"><strong>Core Policy:</strong> Advertising accelerates visibility, Stars embody proven reputation</div>
              </div>
            </div>
          </div>
        </div>
      </section></CleanContent>
  );
}
